import { FC } from 'react';
import { TextKey } from '@mews-commander/enums';
import { LocalizedParagraph } from '@mews-commander/ui';
import { Stack, WithChildren } from '@optimus-web/core';
import { MainSectionLayout } from '../../components/Layouts/MainSectionLayout';
import { LocalizedSectionTitleLarge } from '../../components/Typography';
import { ConsentText } from './ConsentText';

interface MainSectionProps extends WithChildren {
    isConsentTextShown?: boolean;
    isFullHeight?: boolean;
}

export const MainSection: FC<MainSectionProps> = ({ children, isConsentTextShown, isFullHeight }) => (
    <MainSectionLayout isFullHeight={isFullHeight}>
        <Stack vertical spacing="300" alignment="center" itemAlignment="start">
            <LocalizedSectionTitleLarge textKey={TextKey.FinancialServicesCapitalFlexibleFinancing} />
            <Stack vertical spacing="400" itemAlignment="start">
                <LocalizedParagraph textKey={TextKey.FinancialServicesCapitalInvestInSuccess} variant="secondary" />
                {children}
            </Stack>
            {isConsentTextShown && <ConsentText />}
        </Stack>
    </MainSectionLayout>
);
